// Basic
import PropTypes from 'prop-types';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterConfirmation from '@/common-utils/components/renders/modal/components/footers/FooterConfirmation/FooterConfirmation';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.handleValidate
 * @param root0.isLoading
 * @param root0.email
 * @returns {JSX} ModalDeleteEmail
 */
function ModalDeleteEmail({ isOpen, setIsOpen, handleValidate, isLoading, email }) {
    return <Modal open={isOpen} onOpenChange={setIsOpen}>
        <ModalContent className={cn('max-w-2xl')}>
            <HeaderTitle title='modal.delete_mail.title' namespace={nsOrganization} />
            <ModalBody>
                <div className='text-center grid gap-6'>
                    <Entity
                        entity={'modal.delete_mail.message'}
                        namespace={nsOrganization}
                        data={{ email: email }}
                        className='text-base text-center font-semibold'
                    />
                    <Entity
                        entity={'modal.delete_mail.confirm'}
                        namespace={nsOrganization}
                        className='text-base text-center font-semibold'
                    />
                </div>
            </ModalBody>
            <FooterConfirmation
                onValidation={handleValidate}
                isSubmitDisabled={isLoading}
            />
        </ModalContent>
    </Modal>;
}

ModalDeleteEmail.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    handleValidate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired
};

export default ModalDeleteEmail;